/** Contribution d'un point global à chaque affinité ou résistance élémentaire. */
export const GLOBAL_ELEMENT_RATIO = 0.2;

export const ELEMENT_STAT_IDS = [
  'fire', 'ice', 'lightning', 'earth', 'wind', 'holy', 'dark', 'water', 'nature',
] as const;

export const TERTIARY_STAT_KEYS = [
  'affinityGlobal', 'resistanceGlobal',
  ...ELEMENT_STAT_IDS.flatMap((element) => [`affinity_${element}`, `resistance_${element}`]),
] as const;
